import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Container, Row } from "react-bootstrap";
import iconss2 from "../../../assets/iconss2.png";
import iconss3 from "../../../assets/iconss3.png";
import iconss4 from "../../../assets/iconss4.png";
import logo1 from "../../../assets/logo 1.png";
import dateIcon from "../../../assets/blackDateIcon.png";
import timeIcon from "../../../assets/blackTimeIcon.png";
import Ellipse from "../../../assets/Ellipse.png";
import { useParams } from "react-router-dom";
import { userRequest } from "../../../requestMethod";

function ViewNotificationDetails() {
  const { id } = useParams();
  const [notification, setNotification] = useState();
  const [formattedReleaseDate, setFormattedReleaseDate] = useState("");
  const [formattedReleaseTime, setFormattedReleaseTime] = useState("");


  const formatTime = (hours, minutes) => {
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
    const formattedMinutes = minutes.toString().padStart(2, '0');
    return `${formattedHours}:${formattedMinutes} ${period}`;
  };

  useEffect(() => {
    if (id) {
      userRequest(`/api/notification/getNotificationbyId?_id=${id}`).then(
        (res) => {
          setNotification(res.data.data);
          const options = {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
          };
  
          const formattedReleaseDate = new Date(res.data.data?.releaseDate).toLocaleDateString('en-GB', options);
  
          // Parse and format release time
          const [hours, minutes] = res.data.data?.releaseTime.split(":");
          const formattedReleaseTime = formatTime(parseInt(hours), parseInt(minutes));
          setFormattedReleaseDate(formattedReleaseDate);
          setFormattedReleaseTime(formattedReleaseTime);
        }
      );
    }
  }, [id]);


  return (
    <div className={styles.mainContainerss}>
      <Container fluid>
        <Row>
          <Col sm={12} xxl={5} lg={5} className={styles.columnWithBorder}>
            <div className={styles.breadCrumb}>
              <span>
                All Advertisement {">"}{" "}
                <b style={{ opacity: "100%", color: "#131313" }}>
                  Advertisement Stats
                </b>
              </span>
            </div>

            <h1 className={styles.mainNotification}>Notification</h1>
            <div>
              <h3 className={styles.Title}>Title*</h3>
              <p className={styles.titleText}>
                {/* <img className={styles.allicons} src={iconss4} alt="iconss" />
                <img src={iconss3} alt="iconss" />
                <img src={iconss2} alt="iconss" /> */}
                <span>{notification?.title} </span>
              </p>
              <h3 className={styles.body}>Body*</h3>
              <p className={styles.ptag}>
                {notification?.body}
              </p>
              <h3 className={styles.body}>City*</h3>
              <p className={styles.ptag}>India</p>
              <h3 className={styles.body}>Released on*</h3>
              <p className={styles.ptag}>
                <img src={dateIcon} alt="missing" />
                <span>{formattedReleaseDate}</span>
                <img src={timeIcon} alt="missing" />
                <span>{formattedReleaseTime}</span>
              </p>
            </div>
          </Col>

          <Col sm={12} xxl={6} lg={7}>
            <div className={styles.previews}>
              <h1 className={styles.h1text}>Preview</h1>
              <div
                className={styles.ellipse}
                style={{ backgroundImage: `url(${Ellipse})` }}
              >
                <img src={logo1} alt="Logo" className={styles.centeredLogo} />
              </div>
              <h3 className={styles.restaurant}>
                {/* <img className={styles.allicons2} src={iconss4} alt="iconss" />
                <img className={styles.allicons3} src={iconss3} alt="iconss" />
                <img className={styles.allicons3} src={iconss2} alt="iconss" /> */}
                <span className={styles.blackfriday}>
                {notification?.title}
                </span>
              </h3>
              <p className={styles.ptext4}>
              {notification?.body}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ViewNotificationDetails;
